import { Box, IconButton } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { useGame } from 'contexts/Game/Game';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import * as setup from 'setup';
import { InfoTooltip } from './Info.styled';

export default function Info({ name, tabIndex }: InfoProps) {
    const content = useContent();
    const game = useGame();

    const html = useMemo(() => {
        return {
            __html: content.parseHtml(setup.game.info[name], {
                startingBudget: game.startingBudget,
            }),
        };
    }, [content, game.startingBudget, name]);

    const title = <Box dangerouslySetInnerHTML={html} />;

    return (
        <InfoTooltip title={title}>
            <IconButton className="info" disableRipple tabIndex={tabIndex}>
                <MaterialSymbol aria-hidden icon="info" size={16} />
            </IconButton>
        </InfoTooltip>
    );
}
